import React, { Component, Fragment } from 'react';
import { Row, Col, Label, Button } from "reactstrap";
import { inject, observer } from "mobx-react";
import { toJS } from 'mobx';
import InputSelect from '../../comum/tables/components/inputs/InputSelect';
import InputText from '../../comum/tables/components/inputs/InputText';
import { E_CONDICAO, E_TIPO_CLIENTE, E_TIPO_TELA } from '../stores/Enum';
import { IconeDelete, IconeSoma } from '../../comum/components/Icones';
import CheckboxField from '../../comum/components/CheckboxField';
import AddServicosAcessorios from './AddServicosAcessorios';
import { terminal as TERMINAL } from '../../../config/Constantes';
import ServicosAcessoriosPopOver from './ServicosAcessoriosPopOver';

@inject("store")
@observer
export default class DetalhesCabContainer extends Component {
    constructor(props) {
        super(props)

        this.dataStore = this.props.controllers.dataStore;
        this.viewStore = this.props.controllers.viewStore;
        this.filterStore = this.props.controllers.filterStore;
        this.cabStore = this.props.controllers.cabStore;
        this.appStore = this.props.store.appStore;
        this.modalStore = this.props.store.modalStoreCustom;        
    }
    
    numberHandler = (index) => ({ target }) => {
        let newValue = '';

        const numberValue = parseInt(target.value.replace(/\D/gm,''), 10);
        if (!isNaN(numberValue)) newValue = numberValue;

        this.cabStore.setContainer(index, target.name, newValue)
    }

    render() {
        const { cntr: { Cntr, Quantidade, Tipo, Status, TipoCntr, Especial, Imo, Erros }, index} = this.props;

        const temArmador = this.filterStore.tipoCliente == E_TIPO_CLIENTE.Armador;

        const showTitle = this.appStore.isMobile || index === 0;

        const servicosAcessoriosPorItem = this.cabStore.getServicosIncluidosPorIndex(index).filter(s => s.Basico == E_CONDICAO.Nao);
        
        const ErroItem = Erros['Item'];
        const ErroNum = (Erros['Tipo'] || Erros['Status'] || Erros['TipoCntr'] );

        return (
            <Fragment>
                <Row className="w-100 mb-3" style={{ borderBottom: this.appStore.isMobile ? '2px solid #dee2e6' : ''}}>
                    <Col xs={12} sm={12} md={6} lg={2} xl={temArmador && TERMINAL === "SSA" ? 1 : 2}
                        className={`d-flex align-items-center pl-2 ${this.appStore.isMobile ? 'mb-3' : ''}`}
                    >
                        <Col xs={1} sm={1} md={1} lg={1} xl={1} className="">
                            <div className='w-100'>
                                {showTitle &&
                                    <Label className="font-weight-bold" style={{ borderBottom:'2px solid #001C43', maxWidth: 'max-content' }}>Nº</Label>
                                }
                                <Label className="font-weight-bold pt-2">{Cntr}</Label>
                                {(ErroNum || Erros['Quantidade']) && <Label className="label-danger">&nbsp;</Label>}
                            </div>
                        </Col>
                        <InputText xs={11} sm={11} md={11} lg={11} xl={11}
                            title={showTitle ? "Qtd. Cntr" : ""}
                            noTitle={!showTitle}
                            name="Quantidade"
                            value={Quantidade}
                            onChange={this.numberHandler(index)}
                            className="pr-0 mb-0"
                            disabled={this.viewStore.servicosAtivo}
                            error={Erros['Quantidade'] ? Erros['Quantidade'] : (ErroNum ? "\u00A0" : '')}
                        />
                    </Col>
                    <InputSelect xs={12} sm={12} md={6} lg={temArmador && TERMINAL === "SSA" ? 1 : 2} xl={temArmador && TERMINAL === "SSA" ? 1 : 2}
                        title={showTitle ? "Tipo" : ""}
                        noTitle={!showTitle}
                        name="Tipo"
                        options={toJS(this.cabStore.opcoesTiposContainer.value)}
                        onChange={opt => this.cabStore.setContainer(index, 'Tipo', opt ? opt : null)}
                        value={Tipo ? this.cabStore.opcoesTiposContainer.value.find(o => o.value == Tipo.value) : null}
                        disabled={this.viewStore.servicosAtivo}
                        loading={this.cabStore.opcoesTiposContainer.loading}
                        className={`pr-0  ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                        error={Erros['Tipo']}
                    />
                    {temArmador && 
                        <InputSelect xs={12} sm={12} md={6} lg={3} xl={2}
                            title={showTitle ? "Status" : ""}
                            noTitle={!showTitle}
                            name="Status"
                            options={toJS(this.cabStore.opcoesStatusContainer.value)}
                            onChange={opt => this.cabStore.setContainer(index, 'Status', opt ? opt : null)}
                            value={Status ? this.cabStore.opcoesStatusContainer.value.find(o => o.value == Status.value) : null}
                            disabled={this.viewStore.servicosAtivo}
                            loading={this.cabStore.opcoesStatusContainer.loading}
                            className={`pr-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                            error={Erros['Status']}
                        />                        
                    }
                    <InputSelect xs={12} sm={12} md={6} lg={TERMINAL === "SSA" ? 2 : 3} xl={TERMINAL === "SSA" ? 2 : 3}
                        title={showTitle ? "Tipo Cntr" : ""}
                        noTitle={!showTitle}
                        name="TipoCntr"
                        options={this.cabStore.opcoesTipoCntrFiltradasPorIndex(index)}
                        onChange={opt => this.cabStore.setContainer(index, 'TipoCntr', opt ? opt : null)}
                        value={TipoCntr ? this.cabStore.opcoesTipoCntr.value.find(o => o.value == TipoCntr.value) : null}
                        disabled={this.viewStore.servicosAtivo}
                        loading={this.cabStore.opcoesTipoCntr.loading}
                        className={`pr-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                        error={Erros['TipoCntr']}
                    />                 
                    <CheckboxField xs={12} sm={12} md={6} lg={TERMINAL === "RIG" ? 2 : 1} xl={TERMINAL === "RIG" ? 2 : 1}
                        widthAuto={true}
                        backgroundWhite={true}
                        titulo={showTitle ? `Especial${TERMINAL === "RIG" ? '/Imo' : ''} ?` : ""}
                        noTitle={!showTitle}
                        text={"Sim"}
                        ativo={Especial}
                        onClick={(value)=>this.cabStore.setContainer(index, 'Especial', value)}
                        className={`pr-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                        bloqueado={this.cabStore.disableEspecialOption(index) || this.viewStore.servicosAtivo}
                    />
                    {TERMINAL === "SSA" && (
                        <Fragment>
                            <CheckboxField xs={12} sm={12} md={6} lg={3} xl={1}
                                widthAuto={true}
                                backgroundWhite={true}
                                titulo={showTitle ? "Imo?" : ""}
                                noTitle={!showTitle}                                        
                                text={"Sim"}
                                ativo={Imo}
                                onClick={(value)=>this.cabStore.setContainer(index, 'Imo', value)}
                                className={`pr-0 ${this.appStore.isMobile ? 'mb-3' : 'mb-0'}`}
                                bloqueado={this.viewStore.servicosAtivo}
                            />
                        </Fragment>
                    )}
                    {(this.cabStore.data.value.Containers.length > 1 && !this.viewStore.servicosAtivo) &&
                        <Col xs={12} sm={12} md={6} lg={3} xl={1} className={"d-flex flex-column"}>
                            {showTitle && <Label className="footer-select--label">&nbsp;</Label>} 
                            <Button outline className="collapseItem"
                                onClick={() => this.cabStore.removeContainer(index, Cntr)}>
                                <IconeDelete tamanho="sm" />
                            </Button>
                        </Col>                    
                    }
                    {this.viewStore.servicosAtivo &&  
                        <Col xs={12} sm={12} md={6} lg={1} xl={1} className={"d-flex align-items-end"} >
                            <div className="w-100 d-flex flex-column">
                                {showTitle && <Label className="footer-select--label">Serviços</Label>} 
                                <AddServicosAcessorios
                                    className="collapseItem mr-3"
                                    controllers={this.props.controllers}
                                    tipoTela={E_TIPO_TELA.Cabotagem}
                                    items={[this.cabStore.getCntr(index)]}
                                > 
                                    <IconeSoma tamanho="sm" />
                                </AddServicosAcessorios>
                            </div>
                            {servicosAcessoriosPorItem.length > 0 && (
                                <ServicosAcessoriosPopOver
                                    servicosAcessorios={servicosAcessoriosPorItem}
                                    removeServico={this.cabStore.removeServico}
                                />
                            )}
                        </Col>
                    }
                </Row>
                {ErroItem && 
                    <div className="d-flex p-1 mb-4 mt-n3 align-self-center col-11"
                        style={{borderRadius: '5px',backgroundColor: 'rgba(234, 84, 85, 0.12)'}}
                    >
                        <div className="d-flex w-100 justify-content-center align-items-center">
                            <div style={{color: '#ea5455', fontWeight: '800'}}> 
                                {ErroItem}
                            </div>
                        </div>
                    </div>                    
                }                
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/DetalhesCabContainer.js